import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { ConnectorTestValuesType } from '../../../types'

export const collection = 'connectorTestData'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, testValues: ConnectorTestValuesType) =>
    callApi(`${apiBase}/connectors/testData`, schema, {
      method: 'POST',
      body: {
        typedValues: testValues,
      },
    })
